import { SvgIcon, SvgIconProps } from '@mui/material';
import { keyframes } from '@mui/material/styles';

type Props = SvgIconProps;

// Adapted from CC's Spinner: CC renders a single blue PNG frame
// (`/Property 1=Default.png`) rotated via a `.cc-spinner-frame` keyframe
// declared globally in CC's index.css. Neither the image asset nor that
// global stylesheet exists in this repo, so this is reimplemented as a
// self-contained inline-SVG ring using the same rotation timing — no extra
// asset, no dependency on global CSS, and it still renders an <svg> like
// every other icon in this set.
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export function Spinner(props: Props) {
  return (
    <SvgIcon
      {...props}
      titleAccess={props.titleAccess ?? 'loading'}
      sx={{
        animation: `${spin} 1400ms linear infinite`,
        ...props.sx,
      }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2" />
        <path d="M21 12C21 7.02944 16.9706 3 12 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </SvgIcon>
  );
}
